<template>
  <div>
    <NavBar />
    <Edit
      :item="currentItem"
      :editorFunction="editorFunction"
      :close="closeEditor"
      :onSuccess="onEditSuccess"
    />
    <div class="container">
      <SideBar />
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <div class="message" v-if="error">Erro: {{ error.message }}</div>
          <h1 class="title">
            <svg viewBox="0 -31 512 512" xmlns="http://www.w3.org/2000/svg">
              <path d="m211 240h90v30h-90zm0 0" />
              <path
                d="m415.378906 270h-84.378906v15c0 8.289062-6.710938 15-15 15h-120c-8.289062 0-15-6.710938-15-15v-15h-84.378906c-19.394532 0-36.546875-12.363281-42.6875-30.761719l-53.933594-161.828125v327.589844c0 24.8125 20.1875 45 45 45h422c24.8125 0 45-20.1875 45-45v-327.578125l-53.9375 161.816406c-6.136719 18.398438-23.289062 30.761719-42.683594 30.761719zm0 0"
              />
              <path
                d="m316 0h-120c-24.8125 0-45 20.1875-45 45v15h-125.191406l56.574218 169.746094c2.050782 6.136718 7.777344 10.253906 14.238282 10.253906h84.378906v-15c0-8.289062 6.710938-15 15-15h120c8.289062 0 15 6.710938 15 15v15h84.378906c6.460938 0 12.1875-4.117188 14.238282-10.253906l56.578124-169.746094h-125.195312v-15c0-24.8125-20.1875-45-45-45zm-135 60v-15c0-8.277344 6.722656-15 15-15h120c8.277344 0 15 6.722656 15 15v15zm0 0"
              />
            </svg>
            Trabalhe Conosco
          </h1>

          <div class="card">
            <div class="card-body">
              <form class="form-single" v-on:submit.prevent="onSubmit">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for>Título</label>
                      <input type="text" class="form-control" v-model="data.titulo" />
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-group">
                      <label for>Descrição</label>
                      <textarea
                        style="resize: none;"
                        class="form-control"
                        v-model="data.descricao"
                      />
                    </div>
                  </div>
                </div>
                <button class="button button-success">Alterar</button>
              </form>

              <table class="table">
                <thead>
                  <tr>
                    <th>Titulo</th>
                    <th>Ordem</th>
                    <th>
                      <button
                        class="button button-success button-sm button-block"
                        v-on:click="openEditor(-1)"
                      >
                        <svg
                          style="width: 12px; height: 12px; fill: #fff;"
                          x="0px"
                          y="0px"
                          viewBox="0 0 42 42"
                        >
                          <path
                            d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"
                          />
                        </svg>
                        Adicionar
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody v-if="data.items">
                  <tr v-for="(item, index) in data.items" v-bind:key="index">
                    <td>{{ item.titulo }}</td>
                    <td>
                      <span class="label primary">{{ item.ordem }}</span>
                    </td>

                    <td class="actions">
                      <a class="button button-primary" v-on:click="openEditor(index)">
                        <svg
                          x="0px"
                          y="0px"
                          style="margin-top: 4px; width: 12px; height: 12px; fill: #fff;"
                          viewBox="0 0 485.219 485.22"
                        >
                          <g>
                            <path
                              d="M467.476,146.438l-21.445,21.455L317.35,39.23l21.445-21.457c23.689-23.692,62.104-23.692,85.795,0l42.886,42.897 C491.133,84.349,491.133,122.748,467.476,146.438z M167.233,403.748c-5.922,5.922-5.922,15.513,0,21.436 c5.925,5.955,15.521,5.955,21.443,0L424.59,189.335l-21.469-21.457L167.233,403.748z M60,296.54c-5.925,5.927-5.925,15.514,0,21.44 c5.922,5.923,15.518,5.923,21.443,0L317.35,82.113L295.914,60.67L60,296.54z M338.767,103.54L102.881,339.421 c-11.845,11.822-11.815,31.041,0,42.886c11.85,11.846,31.038,11.901,42.914-0.032l235.886-235.837L338.767,103.54z M145.734,446.572c-7.253-7.262-10.749-16.465-12.05-25.948c-3.083,0.476-6.188,0.919-9.36,0.919 c-16.202,0-31.419-6.333-42.881-17.795c-11.462-11.491-17.77-26.687-17.77-42.887c0-2.954,0.443-5.833,0.859-8.703 c-9.803-1.335-18.864-5.629-25.972-12.737c-0.682-0.677-0.917-1.596-1.538-2.338L0,485.216l147.748-36.986 C147.097,447.637,146.36,447.193,145.734,446.572z"
                            />
                          </g>
                        </svg>
                      </a>
                      &nbsp;
                      <button
                        class="button button-error"
                        v-on:click="deleteItem(index)"
                      >
                        <svg
                          style="margin-top: 4px; width: 12px; height: 12px; fill: #fff;"
                          x="0px"
                          y="0px"
                          viewBox="0 0 459 459"
                        >
                          <g>
                            <path
                              d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"
                            />
                          </g>
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Edit from "./Edit";
import { get, post, put, del, uploadImage } from "@/helpers/apiRequest";
import { getImage } from "@/helpers/utils";
const url = "/trabalhe-conosco";
const pageUrl = `${url}/page`;
const itemsUrl = `${url}/items`;

const PAGE_MODEL = {
  titulo: "",
  descricao: "",
  items: []
};

const ITEM_MODEL = {
  titulo: "",
  ordem: 1,
  conteudo: "<p> Descrição... </p>",
  ativaFormulario: 0,
  emailDestino: ''
};

export default {
  components: {
    Edit
  },
  name: "trabalheConosco",
  data() {
    return {
      loading: false,
      error: null,
      editorFunction: () => {},
      data: { ...PAGE_MODEL },
      currentItem: { ...ITEM_MODEL },
      currentIndex: 0
    };
  },
  methods: {
    getImage: getImage,
    openEditor(index = -1) {
      this.currentIndex = index;
      if (index < 0) {
        this.currentItem = { ...ITEM_MODEL };
        this.editorFunction = this.createItem();
      } else {
        this.currentItem = { ...this.data.items[index] };
        this.editorFunction = this.updateItem();
      }

      this.$modal.show("editTrabalheConosco");
    },
    closeEditor() {
      this.currentItem = { ...ITEM_MODEL };
      this.$modal.hide("editTrabalheConosco");
    },

    onEditSuccess() {
      this.$modal.hide("editTrabalheConosco");
      this.fetchData();
    },

    edit(apiMethod, onSuccess, onError, onFinish) {
      this.loading = true;
      return apiMethod()
        .then(json => {
          this.error = null;
          if (onSuccess && typeof onSuccess === "function") {
            onSuccess();
          }
        })
        .catch(err => {
          this.error = err;
          if (onError && typeof onError === "function") {
            onError();
          }
        })
        .finally(() => {
          this.loading = false;
          if (onFinish && typeof onFinish === "function") {
            onFinish();
          }
        });
    },

    updateItem(callback) {
      const { _id } = this.data;
      const index = this.currentIndex;
      const apiMethod = put.bind(this, itemsUrl, {
        _id,
        index,
        item: this.currentItem
      });
      return this.edit.bind(this, apiMethod);
    },

    createItem(callback) {
      const { _id } = this.data;
      const apiMethod = post.bind(this, itemsUrl, {
        _id,
        items: [this.currentItem, ...this.data.items]
      });
      return this.edit.bind(this, apiMethod);
    },

    deleteItem(index, callback) {
      this.$swal({
        title: "Confirma remover?",
        showCancelButton: true,
        type: "error",
        confirmButtonColor: "#d82727"
      }).then(() => {
        const { _id } = this.data;
        const item = this.data.items[index];
        const apiMethod = del.bind(this, itemsUrl, {
          _id,
          item
        });
        this.edit(apiMethod, this.onEditSuccess);
      });
    },

    onSubmit() {
      this.savePage();
    },

    savePage() {
      this.loading = true;
      const { _id, titulo, descricao } = this.data;
      put(`${pageUrl}`, { _id, titulo, descricao })
        .then(json => {
          this.$swal({ title: "Alterado com sucesso", type: "success" });
        })
        .catch(err => {
          this.$swal({ title: err.message, type: "error" });
        })
        .finally(() => {
          this.loading = false;
          this.fetchData();
        });
    },

    fetchData(callback) {
      this.loading = true;
      get(url)
        .then(json => {
          this.data = json;
          this.error = null;
        })
        .catch(err => {
          this.error = err;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },

  beforeMount() {
    this.fetchData();
  }
};
</script>


// WEBPACK FOOTER //
// src/views/TrabalheConosco/TrabalheConosco.vue